/**
 * ================================================================
 * GLOBAL SUPPLIERS - THEME JAVASCRIPT
 * ================================================================
 * Client-side JavaScript for theme interactions:
 * - Theme toggle (dark/light mode)
 * - Scroll buttons (top/bottom)
 * - Cart count updates
 * - Product filtering
 * - Smooth animations
 * ================================================================
 */

// ================================================================
// 1. THEME TOGGLE - REAL-TIME LIGHT/DARK MODE
// ================================================================
function toggleTheme() {
    const html = document.documentElement;
    const currentTheme = html.getAttribute('data-theme') || 'dark';
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    // Apply theme immediately
    html.setAttribute('data-theme', newTheme);
    html.classList.remove('theme-dark', 'theme-light');
    html.classList.add('theme-' + newTheme);
    localStorage.setItem('theme', newTheme);

    // Update CSS variables in real-time
    updateThemeStyles(newTheme);

    // Update icon
    const icon = document.getElementById('themeIcon');
    if (icon) {
        icon.className = newTheme === 'dark' ? 'fas fa-moon' : 'fas fa-sun';
    }
    
    // Update text if exists
    const themeToggleText = document.getElementById('themeToggleText');
    if (themeToggleText) {
        themeToggleText.textContent = newTheme === 'dark' ? 'Light Mode' : 'Dark Mode';
    }
}

// Update theme styles in real-time
function updateThemeStyles(theme) {
    const root = document.documentElement;
    if (theme === 'light') {
        root.style.setProperty('--bg-deep', '#f8fafc');
        root.style.setProperty('--bg-card', '#ffffff');
        root.style.setProperty('--bg-card-content', '#f1f5f9');
        root.style.setProperty('--text-primary', '#1e293b');
        root.style.setProperty('--text-secondary', '#64748b');
        root.style.setProperty('--border-color', '#e2e8f0');
        document.body.style.backgroundColor = '#f8fafc';
        document.body.style.color = '#1e293b';
    } else {
        root.style.setProperty('--bg-deep', '#1a2332');
        root.style.setProperty('--bg-card', '#243447');
        root.style.setProperty('--bg-card-content', '#2d4053');
        root.style.setProperty('--text-primary', '#f8fafc');
        root.style.setProperty('--text-secondary', '#a8b8d0');
        root.style.setProperty('--border-color', '#2d4053');
        document.body.style.backgroundColor = '#1a2332';
        document.body.style.color = '#f8fafc';
    }
}

// Initialize theme from localStorage
document.addEventListener('DOMContentLoaded', function () {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    document.documentElement.setAttribute('data-theme', savedTheme);
    document.documentElement.classList.add('theme-' + savedTheme);
    updateThemeStyles(savedTheme);

    const icon = document.getElementById('themeIcon');
    if (icon) {
        icon.className = savedTheme === 'dark' ? 'fas fa-moon' : 'fas fa-sun';
    }
    
    const themeToggleText = document.getElementById('themeToggleText');
    if (themeToggleText) {
        themeToggleText.textContent = savedTheme === 'dark' ? 'Light Mode' : 'Dark Mode';
    }
});

// Make toggleTheme globally accessible
window.toggleTheme = toggleTheme;

// ================================================================
// 2. SCROLL BUTTONS
// ================================================================
window.addEventListener('scroll', function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    const topButton = document.getElementById('scrollToTop');
    const bottomButton = document.getElementById('scrollToBottom');

    if (topButton) {
        if (scrollTop > 300) {
            topButton.classList.add('visible');
        } else {
            topButton.classList.remove('visible');
        }
    }

    if (bottomButton) {
        if (scrollTop + clientHeight < scrollHeight - 300) {
            bottomButton.classList.add('visible');
        } else {
            bottomButton.classList.remove('visible');
        }
    }
});

// Scroll to top
if (document.getElementById('scrollToTop')) {
    document.getElementById('scrollToTop').addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

// Scroll to bottom
if (document.getElementById('scrollToBottom')) {
    document.getElementById('scrollToBottom').addEventListener('click', function () {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    });
}

// ================================================================
// 3. CART COUNT UPDATE
// ================================================================
function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartCount = document.getElementById('cartCount');
            if (cartCount) {
                cartCount.textContent = cart.item_count;
                if (cart.item_count > 0) {
                    cartCount.classList.remove('hidden');
                    cartCount.style.display = 'flex';
                } else {
                    cartCount.classList.add('hidden');
                    cartCount.style.display = 'none';
                }
            }
        })
        .catch(error => console.error('Error updating cart count:', error));
}

// Update cart count on page load
document.addEventListener('DOMContentLoaded', updateCartCount);

// Update cart count after adding to cart
document.addEventListener('submit', function (e) {
    if (e.target.action && e.target.action.includes('/cart/add')) {
        // Wait for cart to update, then refresh count
        setTimeout(updateCartCount, 500);
    }
});

// ================================================================
// 4. PROFILE DROPDOWN
// ================================================================
function toggleProfileDropdown() {
    const dropdown = document.getElementById('profileDropdown');
    if (dropdown) {
        dropdown.classList.toggle('active');
    }
}

// Close dropdown when clicking outside
document.addEventListener('click', function (event) {
    const profileContainer = document.querySelector('.profile-container');
    const dropdown = document.getElementById('profileDropdown');

    if (profileContainer && dropdown && !profileContainer.contains(event.target)) {
        dropdown.classList.remove('active');
    }
});

// ================================================================
// 5. CATEGORY FILTERING
// ================================================================
function filterByCategory(category) {
    const products = document.querySelectorAll('.product-card');

    products.forEach(product => {
        if (category === 'all' || product.dataset.category === category) {
            product.style.display = 'block';
            product.style.animation = 'fadeInUp 0.5s ease-out';
        } else {
            product.style.display = 'none';
        }
    });

    // Update active category chip
    document.querySelectorAll('.category-chip').forEach(chip => {
        chip.classList.remove('active');
    });
    event.target.classList.add('active');
}

// ================================================================
// 6. PRODUCT SEARCH
// ================================================================
function searchProducts(query) {
    const searchLower = query.toLowerCase();
    const products = document.querySelectorAll('.product-card');

    products.forEach(product => {
        const title = product.querySelector('.product-title')?.textContent.toLowerCase() || '';

        if (title.includes(searchLower)) {
            product.style.display = 'block';
        } else {
            product.style.display = 'none';
        }
    });
}

// ================================================================
// 7. ADD TO CART WITH FEEDBACK
// ================================================================
function addToCart(variantId, quantity = 1) {
    const formData = {
        items: [{
            id: variantId,
            quantity: quantity
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            updateCartCount();

            // Show success notification (could add a toast notification here)
            alert('Product added to cart!');
        })
        .catch((error) => {
            console.error('Error:', error);
            alert('Error adding product to cart');
        });
}

// ================================================================
// 8. IMAGE GALLERY (Product Page)
// ================================================================
function initImageGallery() {
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const mainImage = document.querySelector('.product-main-image');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function () {
            const newSrc = this.dataset.imageSrc;
            if (newSrc) {
                mainImage.src = newSrc;

                // Update active thumbnail
                thumbnails.forEach(t => t.classList.remove('active'));
                this.classList.add('active');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initImageGallery);

// ================================================================
// 9. SMOOTH ANIMATIONS ON SCROLL
// ================================================================
function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, {
        threshold: 0.1
    });

    document.querySelectorAll('.product-card').forEach(card => {
        observer.observe(card);
    });
}

document.addEventListener('DOMContentLoaded', initScrollAnimations);

// ================================================================
// 10. VARIANT SELECTOR (Product Page)
// ================================================================
function initVariantSelector() {
    const selector = document.getElementById('variantSelector');
    const variantIdInput = document.getElementById('variantId');

    if (selector && variantIdInput) {
        selector.addEventListener('change', function () {
            variantIdInput.value = this.value;

            // Update price if needed
            const selectedOption = this.options[this.selectedIndex];
            const price = selectedOption.dataset.price;

            if (price) {
                const priceDisplay = document.querySelector('.product-price');
                if (priceDisplay) {
                    priceDisplay.textContent = `$${price}`;
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', initVariantSelector);

// ================================================================
// 11. UTILITIES
// ================================================================

// Debounce function for search
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Format price
function formatPrice(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}

// Expose functions globally for inline event handlers
window.toggleTheme = toggleTheme;
window.toggleProfileDropdown = toggleProfileDropdown;
window.filterByCategory = filterByCategory;
window.searchProducts = searchProducts;
window.addToCart = addToCart;

// Add to cart and redirect to cart page
function addToCartAndRedirect(variantId) {
    const formData = {
        items: [{
            id: variantId,
            quantity: 1
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === 422) {
            alert('Error: ' + data.description);
        } else {
            window.location.href = '/cart';
        }
    })
    .catch((error) => {
        console.error('Error:', error);
        alert('Error adding product to cart');
    });
}
window.addToCartAndRedirect = addToCartAndRedirect;

// ================================================================
// 12. SHOPIFY AJAX CART (Optional Enhancement)
// ================================================================
class ShopifyCart {
    static async get() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    static async add(variantId, quantity = 1) {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{ id: variantId, quantity }]
            })
        });
        return response.json();
    }

    static async update(lineItemKey, quantity) {
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: { [lineItemKey]: quantity }
            })
        });
        return response.json();
    }

    static async clear() {
        const response = await fetch('/cart/clear.js', { method: 'POST' });
        return response.json();
    }
}

// Export for use in other scripts
window.ShopifyCart = ShopifyCart;

// ================================================================
// 13. DYNAMIC PRODUCT ALGORITHM - OPTIMIZED
// ================================================================
function randomizeAndPrioritizeProducts() {
    const grid = document.getElementById('productsGrid') || document.querySelector('.products-grid');
    if (!grid) return;

    // Hide grid initially to prevent flash
    grid.style.opacity = '0';
    grid.style.visibility = 'hidden';
    grid.style.transition = 'none';

    const cards = Array.from(grid.querySelectorAll('.product-card'));
    if (cards.length < 2) {
        grid.style.opacity = '1';
        grid.style.visibility = 'visible';
        return;
    }

    // Get user history (optimized - only parse once)
    let viewedCategories = [];
    try {
        const stored = localStorage.getItem('viewedCategories');
        if (stored) viewedCategories = JSON.parse(stored);
    } catch (e) {}

    // Calculate scores (optimized loop) - Prioritize latest products
    const scores = [];
    for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        let score = Math.random() * 100;
        const price = parseFloat(card.dataset.price || 0);
        if (price >= 100) score += 50;
        const category = card.dataset.category;
        if (category && viewedCategories.includes(category)) score += 30;
        // Prioritize latest products (majority at top) - MAXIMUM PRIORITY
        const isLatest = card.dataset.isLatest === 'true';
        if (isLatest) {
            score += 500; // Very high priority boost - ensures these appear on top
            // Add additional random boost to keep randomization but keep them at top
            score += Math.random() * 200;
        }
        scores.push({ card, score });
    }

    // Sort by score descending
    scores.sort((a, b) => b.score - a.score);

    // Re-append to grid (optimized - use DocumentFragment)
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < scores.length; i++) {
        fragment.appendChild(scores[i].card);
    }
    grid.innerHTML = '';
    grid.appendChild(fragment);
    
    // Show grid with fade-in animation (use requestAnimationFrame for smooth transition)
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            grid.style.transition = 'opacity 0.15s ease-in, visibility 0.15s ease-in';
            grid.style.opacity = '1';
            grid.style.visibility = 'visible';
        });
    });
}

// Track user history
function trackProductView(category) {
    if (!category) return;
    let viewed = JSON.parse(localStorage.getItem('viewedCategories') || '[]');
    if (!viewed.includes(category)) {
        viewed.push(category);
        if (viewed.length > 5) viewed.shift(); // Keep last 5
        localStorage.setItem('viewedCategories', JSON.stringify(viewed));
    }
}

// Initialize on load - Optimized
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRandomization);
} else {
    initProductRandomization();
}

function initProductRandomization() {
    randomizeAndPrioritizeProducts();
    
    // Add click listeners for tracking (delegated event for performance)
    const grid = document.getElementById('productsGrid') || document.querySelector('.products-grid');
    if (grid) {
        grid.addEventListener('click', function(e) {
            const card = e.target.closest('.product-card');
            if (card) {
                trackProductView(card.dataset.category);
            }
        }, true);
    }
}

console.log('🌌 Global Suppliers Theme Loaded');
